// In this SPA, styled-components should use the nonce from the initial document
// response (e.g. blankie nonce on script/meta/window bootstrap).
//
// Do not rotate nonce from subsequent API responses: that would force a root re-render
// to update StyleSheetManager and can desynchronize old/new style tags.

let cachedNonce;

const readNonceFromDom = () => {

    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return undefined;
    }

    const globalNonce = window.__CSP_NONCE__ || window.__NONCE__;

    if (globalNonce) {
        return globalNonce;
    }

    const nonceMeta = document.querySelector('meta[name="csp-nonce"]');
    const nonceFromMeta = nonceMeta && nonceMeta.getAttribute('content');

    return nonceFromMeta;
};

const resolveCspNonce = () => {

    if (cachedNonce) {
        return cachedNonce;
    }

    cachedNonce = readNonceFromDom();

    if (cachedNonce) {
        if (typeof window !== 'undefined') {
            window.__CSP_NONCE__ = cachedNonce;
        }

        // Ensure webpack-injected async chunk <script> tags inherit CSP nonce.
        __webpack_nonce__ = cachedNonce;
    }

    return cachedNonce;
};

const nonce = resolveCspNonce();

// Monkeypatch document.createElement to add nonce
if (nonce && typeof document !== 'undefined') {
    const originalCreateElement = document.createElement.bind(document);

    document.createElement = function patchedCreateElement(tagName, options) {

        const el = originalCreateElement(tagName, options);

        if (typeof tagName === 'string' && tagName.toLowerCase() === 'style') {
            el.setAttribute('nonce', nonce);
        }

        return el;
    };
}

module.exports = { nonce };
